export default {
  English: 'English',
  Français: 'French',
  Deutsch: 'German',
  Italliano: 'Italian',
  Español: 'Spanish',
  Next: 'Next',
  Back: 'Back',
  //META DATA
  STEP1_META_TITLE: 'Purchase, buy #PR_NAME# for Microsoft Outlook license.',
  STEP1_META_DESCRIPTION: 'Purchase, buy #PR_NAME# license and activation code. Choose your #PR_NAME# License',
  STEP1_META_KEYWORDS: '#PR_NAME#, purchase, order, buy,  license, upgrade',

  STEP2_META_TITLE: 'Purchase, Buy #PR_NAME# Upgrade and Support',
  STEP2_META_DESCRIPTION: 'Purchase, order or buy #PR_NAME# Support and #PR_NAME# Upgrades. Add License Renewal or Lifetime License',
  STEP2_META_KEYWORDS: '#ProductName#, purchase, order, buy, upgrade, support, license, lifetime license ',

  STEP3_META_TITLE: 'Purchase, buy #PR_NAME# for Microsoft Outlook bundles.',
  STEP3_META_DESCRIPTION: 'Purchase, buy #PR_NAME# for Microsoft Outlook bundles. Order #PR_NAME# bundle.',
  STEP3_META_KEYWORDS: '#PR_NAME#, purchase, order, buy, bundle, license',

  STEP4_META_TITLE: 'Purchase, buy Outlook Performance Tune Up.',
  STEP4_META_DESCRIPTION: 'Purchase, buy Outlook Performance Tune Up. Add one session of Outlook configuration, tune up and problem fixing service.',
  STEP4_META_KEYWORDS: 'Outlook Performance Tune Up, purchase, order, buy,  support, license',

  //TOP LINE PAY LATER
  TOP_LINE_PAY_LATER: 'Pay Later.',
  TOP_LINE_PAY_LATER_BAR: 'Interest free bi-weekly payments.',
  TOP_LINE_PAY_LATER_BAR_LINK: 'See how Pay Later works',
  TOP_LINE_PAY_LATER_BLUE_TEXT: 'How it works',
  TOP_LINE_PAY_LATER_FREE_PAYMENTS_HEADER: '{interestPaymentCount} interest free bi-weekly payments of {currency}{amount}',
  TOP_LINE_PAY_LATER_FREE_PAYMENTS_CONTENT: '',

  //PAY LATER MODAL INFO WINDOW
  MODAL_PAY_LATER_EASY_PAY_METHD_SELECTED:
    '<b>If Pay Later method is selected, you will be charged each 2 weeks.</b><br/> You will then be receiving bi-weekly billing statements with payment due and the remaining balance of your order.',
  MODAL_PAY_LATER_LIST_SCHEMA_TEXT_1: 'No fees',
  MODAL_PAY_LATER_LIST_SCHEMA_TEXT_2: 'No approval needed',
  MODAL_PAY_LATER_LIST_SCHEMA_TEXT_3: 'No price increase',
  MODAL_PAY_LATER_SCHEMA_TITLE: '<b>Pay with 2-weeks installments, without price increase.</b>',
  MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_1: '{orderPayment} - {totalOrderSum} - <b>2 payments</b>',
  MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_2: '{orderPayment} - {totalOrderSum} - <b>3 payments</b>',
  MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_3: '{orderPayment} - {totalOrderSum} - <b>4 payments</b>',
  MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_4: '{orderPayment} - {totalOrderSum} - <b>5 payments</b>',
  MODAL_PAY_LATER_TOTAL_ORDER_SUM_LIST_TEXT_5: '{orderPayment} - {totalOrderSum} - <b>6 payments</b>',
  MODAL_PAY_LATER_TOTAL_ORDER_SUM_TITLE: 'Your order is divided into multiple bi-weekly payments according to the total order sum:',

  //STEP 1 TILES
  STEP1_PAGE_H: 'Choose your OST PST Viewer License',
  STEP1_PAGE_H_SHORT: 'Choose License',
  STEP1_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual license',

  TILE_LICENSE_TITLE: '<b>User License</b>',
  TILE_LICENSE_TITLE_DIV: 'User License',
  TILE_LICENSE_DESCRIPTION: '1 year of free upgrades and free support is included.',
  TILE_LICENSE_MODAL_TITLE: '<b>OST PST Viewer User License</b>',
  TILE_LICENSE_DESCRIPTION2: '',
  TILE_LICENSE_MODAL_DESCRIPTION: 'In addition to user license you get 1 year of free upgrades and technical support.',
  TILE_BADGE_LIMITED_OFFER: ' off. Limited Time Offer',

  TILE_SINGLE_LIC_UPGRADE_TITLE: '<b>User License Renewal</b>',
  TILE_SINGLE_LIC_UPGRADE_TITLE_DIV: 'User License Renewal',
  TILE_SINGLE_LIC_UPRAGE_DESCRIPTION: 'If already own a license. Get the latest Product version and additional year of Product Updates and Support.',
  TILE_SINGLE_LIC_UPGRADE_MODAL_TITLE: '<b>OST PST Viewer User License Renewal</b>',
  TILE_SINGLE_LIC_UPGRADE_MODAL_DESCRIPTION: 'If already own a license. Get the latest Product version and additional year of Product Updates and Support.',

  //STEP2
  STEP2_PAGE_H: 'Add License Renewal or Lifetime License',
  STEP2_PAGE_H_SHORT: 'Select Renewal',
  STEP2_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual license',

  TILE_LIC_UPGRADE_TITLE: '<b>License Renewal<br>for Additional Year</b>',
  TILE_LIC_UPGRADE_TITLE_DIV: 'License Renewal for Additional Year',
  TILE_LIC_UPRAGE_DESCRIPTION: 'Add additional year of Upgrade and Maintenance Plan.',
  TILE_LIC_UPGRADE_MODAL_TITLE: 'License Renewal for Additional Year',
  TILE_LIC_UPGRADE_MODAL_DESCRIPTION: 'Get the latest Product version and additional year of Product Updates and Support.',

  TILE_LIFETIME_UPGRADE_TITLE: '<b>Lifetime License Renewal</b>',
  TILE_LIFETIME_UPGRADE_TITLE_DIV: 'Lifetime License Renewal',
  TILE_LIFETIME_UPRAGE_DESCRIPTION: 'Perpetual software license. Lifetime updates and support.',
  TILE_LIFETIME_UPGRADE_MODAL_TITLE: 'Lifetime License Renewal',
  TILE_LIFETIME_UPGRADE_MODAL_DESCRIPTION: 'Perpetual software license. Lifetime updates and support.',

  TILE_TECH_LIC_UPGRADE_TITLE: '<b>Upgrade to OST PST Viewer Technical license</b>',
  TILE_TECH_LIC_UPGRADE_TITLE_DIV: 'Upgrade to OST PST Viewer Technical license',
  TILE_TECH_LIC_UPRAGE_DESCRIPTION: 'Cost-effective solution for technicians.<br/>Unlimited installations. ',
  TILE_TECH_LIC_UPGRADE_MODAL_TITLE: 'Upgrade to OST PST Viewer Technical license',
  TILE_TECH_LIC_UPGRADE_MODAL_DESCRIPTION: 'Cost-effective solution for technicians.<br/>Unlimited installations. ',

  //STEP3
  STEP3_PAGE_H: 'Bundle and Save Big',
  STEP3_PAGE_H_SHORT: 'Bundle',
  STEP3_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual license',

  TILE_BUNDLE_MAIN_TITLE: '<b>PST & OST Management Bundle</b>',
  TILE_BUNDLE_MAIN_TITLE_DIV: 'PST & OST Management Bundle',
  TILE_BUNDLE_MAIN_DESCRIPTION1: 'Merge, split or archive PST files. Convert OST files to PST.',
  TILE_BUNDLE_MAIN_TITLE_MODAL: '<b>PST & OST Management bundle</b>',
  TILE_BUNDLE_MAIN_DESCRIPTION_MODAL: 'Buy PST & OST Management Bundle and you will receive:',
  TILE_BUNDLE_MAIN_S2_DESCRIPTION: ' - Synchronize Microsoft Outlook data between multiple PC’s.',
  TILE_BUNDLE_MAIN_DR_DESCRIPTION: ' - Synchronize Microsoft outlook data with multiple sources: iCloud, Google, Microsoft Exchange.',
  TILE_BUNDLE_MAIN_DR_DESCRIPTION: ' - find and remove Outlook duplicate items in just one click.',
  TILE_BUNDLE_MAIN_SPB_DESCRIPTION: ' - automatic Outlook PST and Exchange folders backup tool.',
  TILE_BUNDLE_MAIN_OT_DESCRIPTION: ' - resolve Outlook problems with Outlook toolbox.',

  TILE_BUNDLE_MAIN_OST2_DESCRIPTION: ' - Convert OST to PST files and connect converted files to Microsoft Outlook',
  TILE_BUNDLE_MAIN_SPLITTER_DESCRIPTION: ' - Split your PST file automatically or manually.',
  TILE_BUNDLE_MAIN_MERGER_DESCRIPTION: ' - Merge multiple PST files into a single file.',
  TILE_BUNDLE_MAIN_VIEWER_DESCRIPTION: ' - View PST and OST files in a few clicks without Microsoft Outlook.',
  TILE_BUNDLE_MAIN_S2_NAME: 'Sync2',
  TILE_BUNDLE_MAIN_S2_URL: 'https://www.sync2.com/',
  TILE_BUNDLE_MAIN_S2C_NAME: 'Sync2 Cloud',
  TILE_BUNDLE_MAIN_S2C_URL: 'https://cloud.sync2.com/',
  TILE_BUNDLE_MAIN_DR_NAME: 'Outlook Duplicate Remover',
  TILE_BUNDLE_MAIN_DR_URL: 'https://www.duplicate-remover.com/',
  TILE_BUNDLE_MAIN_SPB_NAME: 'Safe PST Backup',
  TILE_BUNDLE_MAIN_SPB_URL: 'https://www.safepstbackup.com/',
  TILE_BUNDLE_MAIN_OT_NAME: 'Outlook Toolbox',
  TILE_BUNDLE_MAIN_OT_URL: 'https://outlooksupport.4team.biz/resolve-outlook-problems-with-outlook-toolbox',
  TILE_BUNDLE_MAIN_OST2_NAME: 'OST2',
  TILE_BUNDLE_MAIN_OST2_URL: 'https://www.ost2.com/',
  TILE_BUNDLE_MAIN_SPLITTER_NAME: 'PST Splitter',
  TILE_BUNDLE_MAIN_SPLITTER_URL: 'http://www.pst-file-splitter.com/',
  TILE_BUNDLE_MAIN_MERGER_NAME: 'PST Merger',
  TILE_BUNDLE_MAIN_MERGER_URL: 'http://www.pst-merger.com/',
  TILE_BUNDLE_MAIN_VIEWER_NAME: 'OST PST Viewer',
  TILE_BUNDLE_MAIN_VIEWER_URL: 'https://www.ostpstviewer.com/',

  TILE_BUNDLE_ALLYOUCANEAT_TITLE: '<b>All You Can Eat Bundle</b>',
  TILE_BUNDLE_ALLYOUCANEAT_TITLE_DIV: 'All You Can Eat Bundle',
  TILE_BUNDLE_ALLYOUCANEAT_DESCRIPTION1: 'All 4Team utilities for Microsoft Outlook. Includes synchronization, duplicate management, backup tools.',
  TILE_BUNDLE_ALLYOUCANEAT_TITLE_MODAL: '<b>All You Can Eat Bundle</b>',
  TILE_BUNDLE_ALLYOUCANEAT_DESCRIPTION_MODAL: 'Buy All You Can Eat Bundle and you will receive:',
  TILE_BUNDLE_ALLYOUCANEAT_S2_DESCRIPTION: ' - Synchronize Microsoft Outlook data between multiple PC’s.',
  TILE_BUNDLE_ALLYOUCANEAT_S2C_DESCRIPTION: ' - Synchronize Microsoft outlook data with multiple sources: iCloud, Google, Microsoft Exchange.',
  TILE_BUNDLE_ALLYOUCANEAT_DR_DESCRIPTION: ' - find and remove Outlook duplicate items in just one click.',
  TILE_BUNDLE_ALLYOUCANEAT_SPB_DESCRIPTION: ' - automatic Outlook PST and Exchange folders backup tool.',
  TILE_BUNDLE_ALLYOUCANEAT_OT_DESCRIPTION: ' - resolve Outlook problems with Outlook toolbox.',
  TILE_BUNDLE_ALLYOUCANEAT_AND_MORE: 'and more',
  TILE_BADGE_RECOMMENDED: 'Recommended',

  //STEP4
  STEP4_PAGE_H: 'Extras',
  STEP4_PAGE_SHORT: 'Extras',
  STEP4_PAGE_DESCRIPTION: 'Every user account on each PC needs an individual license',
  TILE_OUTLOOKTUNEUP_TITLE: '<b>Outlook Performance<br/>Tune Up</b>',
  TILE_OUTLOOKTUNEUP_TITLE_DIV: 'Outlook Performance Tune Up',
  TILE_OUTLOOKTUNEUP_DESCRIPTION1:
    'An online session with our 5-Star Support Professionals. You will get your Outlook configured, tuned up and fixed in no time!',
  TILE_OUTLOOKTUNEUP_MODAL_TITLE: '<b>Outlook Performance<br/>Tune Up</b>',
  TILE_OUTLOOKTUNEUP_MODAL_DESCRIPTION:
    'An online session with our 5-Star Support Professionals. You will get your Outlook configured, tuned up and fixed in no time!',

  //Tiles buttons
  TILE_BTN_ADD_TO_CART: 'Add to cart',
  TILE_BTN_UNSELECT: 'Unselect',
  TILE_BTN_SELECT: 'Select',
  TILE_BTN_REMOVE: 'Remove',
  TILE_BTN_SELECTED: 'Selected',
  TILE_BTN_CHAT_NOW: 'Chat now',
  TILE_BTN_CLOSE: 'Close',

  //
  SKIP_BNT:'Skip',
  SKIP_BNT_LAST:'Skip',

  //Tiles links
  TILE_LINK_LEARN_MORE: 'Learn more',
  TILE_LINK_WHY_UPGRADE: 'Why Renew?',
  TILE_LINK_WHY_LIFETIME_UPGRADE: 'Why Lifetime License?',
  TILE_LINK_WHY_TECH_LIC_UPGRADE: 'Concurrent use license. Learn more.',

  //Tiles Price & Save
  TILE_PAY_LATER_NAME: 'Pay Later',
  TILE_PAY_LATER_NAME_MODAL: 'Pay Later',
  TILE_PAY_LATER_NUMBER_OF_PAYMENTS: '{numberOfPayments} payments',
  TILE_PAY_LATER_NUMBER_OF_PAYMENTS_MODAL: '{numberOfPayments} payments',
  TILE_PAY_LATER_TEXT: 'or {payLaterText} {br} {numberOfPayments} of {paymentAmount}',
  TILE_PAY_LATER_TEXT_MODAL: 'or {payLaterText} {br} {numberOfPayments} of {paymentAmount}',
  TILE_LISTPRICE_SAVE: 'List Price: {oldPrice} You Save {percentageDiscount}%',
  TILE_LISTPRICE_SAVE_MODAL: 'List Price: {oldPrice} You Save {percentageDiscount}%',

  //MODAL WHY UPGRADE
  MODAL_WHY_UPGRADE_TITLE: 'Why Renew?',
  MODAL_WHY_UPGRADE_DESCTIPTION:
    'With the User License Renewal purchase, you will receive <b>1 year of free software upgrades</b> as well as our <b>free online support via Live Chat</b><br> <b>We highly recommend upgrading your software license annually.</b>',
  MODAL_WHY_UPGRADE_PURCHASE_TITLE: 'How to Purchase the License Renewal?',
  MODAL_WHY_UPGRADE_PURCHASE_TEXT:
    'If you have used the product for more than 1 year and want an upgrade, please select <b>Product Renewal</b>. Then in the shopping cart please select license quantity that you own and want to upgrade. After the order confirmation you are eligable to use the upgraded version of the software for another year.<br><br>Your original license is valid indefinately. If you save the original downloadable program file, you will be able to use it at any time in the future.<br><br>Every user needs an individual license for each PC. If two users use the same PC, they will need two licenses, if they log in to different Windows profiles.',

  //MODAL WHY LIFETIME UPGRADE
  MODAL_WHY_LT_UPGRADE_TITLE: 'Why Purchasing the Lifetime License?',
  MODAL_WHY_LT_UPGRADE_DESCTIPTION:
    '<p>Your original software license is limited to only 1 year of Free Upgrades and Support. Benefits of purchasing the Lifetime Renewal:</p><ul class="modal-description-ul"><li> Substantial money(50% Off) and time savings.</li><li>Paying for the software and its support once you get one code to activate the product.</li ><li>Remove the risk of price increase of software updates and support.</li><li>Free future software upgrades and updates.</li><li>Free software technical support via email and Live Chat.</li><li>You will be able to transfer license to another PC (3 times/year).</li><li>Special offers for additional licenses and related products and services.</li></ul>',
  MODAL_WHY_LT_UPGRADE_PURCHASE_TITLE: 'How to Purchase the Lifetime License?',
  MODAL_WHY_LT_UPGRADE_PURCHASE_TEXT:
    '<ol class="modal-description-ol"><li> Choose the “Lifetime License Renewal”;</li><li>Select license quantity that you own;</li><li>Free future software upgrades and updates.</li><li>Free software technical support either via email or Live Chat.</li></ol>',
  MODAL_WHY_LT_UPGRADE_NOTE:
    '<a href="testimonials.aspx" title="Read our Customers Reviews or Submit your feedback">Read our Customers Reviews or Submit your feedback</a>. Your opinion is extremely important.',
  //
  DISCOUNTS_AFTER_ADD_TO_CART: 'Discounts, if any, are applied AFTER you click "Add to Cart". You can change license quantity in the Shopping Cart.',
  PAYLATER_AFTER_ADD_TO_CART: 'When available, you can choose the Pay Later option, after Check Out when selecting your payment method.',

  //MODAL WHY Tech lic
  MODAL_WHY_TECH_LIC_TITLE: 'OST2 Technical License',
  MODAL_WHY_TECH_LIC_DESCTIPTION:
    "OST2 Technical License is a cost-effective solution for technicians who support and provide services for small offices, organizations and companies. With a single license, the technician can support multiple PCs that may have one or multiple orphaned OST files that contain valuable email, contact and calendar data. There's no limitation of file size or quantity of OST files to convert.",
  MODAL_WHY_TECH_LIC_BENEFITS_TEXT:
    '<ul class="modal-description-ul"><li>Installation support: Unlimited installations on multiple computers, user accounts and on different locations.</li><li>License: concurrent use. Only one software installation can be activated and used per one Technical license at a time. To use the same license on another PC, license deactivation is required.</li><li>License Deactivations: Unlimited. Internet connection required.</li><li>Technical Support: 1 year FREE Unlimited. Chat, e-mail.</li><li>Product Updates: 1 year FREE  Product Updates.</li><li>Electronic Delivery: The delivery of the product is automated. You will receive an e-mail containing both the link to download the product and the Activation Code within a few minutes after payment confirmation. Lincense instant delivery by e-mail.</li><li>Money Back Policy: 14 Day, No questions asked, Money Back guarantee.</li></ul>',
  MODAL_WHY_TECH_LIC_NOTE: 'If you are interested in a custom solution, please fill out our <a href="https://www.ost2.com/questionnaire.aspx"> OST PST Viewer Questionnaire</a>.<br>* To activate the OST PST Viewer Technical license, you must have the software primary license.',


  // MODAL BUNDLES ADDITIONAL TEXT
  MODAL_BUNDLE_BUY_NOW: 'Buy Now',
  MODAL_BUNDLES_BUY_SEPARATELLY: 'If Bought Separately',
  MODAL_BUNDLES_BUY_AS_BUNDLE: 'If Bought as Bundle',

  // MODAL LIFETIME ADDITIONAL TEXT
  MODAL_LIFETIME_BUY_NOW: 'Buy Now',
  MODAL_LIFETIME_BUY_FULL_PRICE: 'Full Price',
  MODAL_LIFETIME_BUY_LIST_PRICE: 'If Bought Separately',

  //PURCHASE STEPS BAR
  STEPS_BAR_BTN_BACK: 'Back',
  STEPS_BAR_STEP1: 'Licenses',
  STEPS_BAR_STEP2: 'Upgrades',
  STEPS_BAR_STEP3: 'Bundles',
  STEPS_BAR_STEP4: 'Extras',
  STEPS_BAR_BTN_NEXT: 'Next',
  STEPS_BAR_BTN_ADD_TO_CART: 'Go to Cart',
  STEP_BAR_SELECT_ANY_OPTON_TOOLTIP: 'Select any option above to proceed',
  STEP_BAR_TRUST_SOFTWARE: 'The software you can trust.',
  STEP_BAR_EULA: 'Licensing (EULA)',
  STEP_BAR_EULA_TITLE: 'Licensing (EULA)',

  //NOTES AND PAYMENT CARDS ICONS
  PAYMENT_TOP_CAPTION: 'No commitment. {privacyPolicy} and {systemRequirements}. The software you can trust. {licensingEula}',
  PAYMENT_MAIN_TEXT_HEADING: 'Money Back Guarantee',
  PAYMENT_MAIN_TEXT:
    '* We are eager to make sure that you will be really happy with your purchase.<br>If you are not satisfied, for any reason at all, please contact us within 14 days from your purchase and we will give you a full refund.',
  PAYMENT_MAIN_TEXT_REFUND: '** Product Bundles are not refundable',
  PAYMENT_MAIN_TEXT_BOTTOM: 'Refund policy',

  ICON_VISA_TITLE: 'Visa',
  ICON_AMERICAN_EXPRESS_TITLE: 'American Express',
  ICON_MASTER_CARD_TITLE: 'MasterCard',
  ICON_DISCOVER_NETWORK_TITLE: 'Discover',
  ICON_WIRE_TRANSFER_TITLE: 'Wire Transfer',
  ICON_PURCHASE_ORDER_TITLE: 'Purchase Order',
  ICON_MONEY_ORDER_TITLE: 'Money Order',
  ICON_CHECK_TITLE: 'Check',
  ICON_PAYPAL_TITLE: 'PayPal',
  ICON_PAY_LATER_TITLE: 'Pay Later',

  ICON_MICROSOFT_GOLD_CERTIFIED_TITLE: 'Microsoft Gold Certified Partner',
  ICON_MONEY_BACK_GUARANTEE_TITLE: 'Money Back Satisfaction guarantee',
  ICON_MONEY_BACK_TITLE: 'Money Back Satisfaction guarantee',

  //INFO LINKS
  PAYMENT_INFO_LINK_RP: 'Refund policy',
  PAYMENT_INFO_LINK_RP_TITLE: 'Refund policy',
  PAYMENT_INFO_LINK_SR: 'System Requirements',
  PAYMENT_INFO_LINK_SR_TITLE: 'System Requirements',
  PAYMENT_INFO_LINK_EULA: 'Licensing (EULA)',
  PAYMENT_INFO_LINK_EULA_TITLE: 'Licensing (EULA)',
  PAYMENT_INFO_LINK_FAQ: 'Frequently Asked Questions',
  PAYMENT_INFO_LINK_FAQ_TITLE: 'Frequently Asked Questions',

  //FOOTER
  FOOTER_BOTTOM_COPYRIGHT: '{corporationName} All rights reserved',
  FOOTER_DISCOUNTS:
    'Discounts, if any, are applied AFTER you click "Add to Cart" and move to the shopping cart page.<br>Multiple discounts are not applied.<br>Product bundles are not refundable.<br>Every user account on each workstation needs an individual license.<br>Every license includes: 1 year of free updates and free support via e-mail and Live Help.<br>Check individual software products for localization information.<br>"Pay Later" price is just one part of payment depending on payment schedule.',
  FOOTER_BOTTOM_MAIN_TEXT:
    'Microsoft and the Office logo are registered trademarks of Microsoft Corporation in the United States and/or other countries. Apple and the iPhone, iCloud, iTunes logos are registered trademarks of Apple Inc. In the United States and/or other countries. Google and the Google Calendar, Google Contacts, Google Tasks logos are registered trademarks of Google LLC. In the United States and/or other countries.',
  FOOTER_BUTTON_NAME_1: 'About Us',
  FOOTER_BUTTON_NAME_2: 'Privacy',
  FOOTER_BUTTON_NAME_3: 'Terms',
  FOOTER_BUTTON_TITLE_1: 'Click here to learn about 4Team Corporation',
  FOOTER_BUTTON_TITLE_2: 'Click here to read Privacy Policy',
  FOOTER_BUTTON_TITLE_3: 'Click here to read Terms of Use',
  FOOTER_BUTTONS_COUNT: '3',
  FOOTER_INPUT_LABEL: 'Keep me posted on the latest news',
  FOOTER_INPUT_PLACEHOLDER: 'Type your Email address here',
  FOOTER_CORPORATION_NAME: '4Team Corporation',
  FOOTER_ICON_TEAM_LOGO_TITLE: '4Team Corporation',
  //EMAIL VALIDATION
  VALIDATION_EMAIL_INVALID: 'Inavalid e-mail.',
  VALIDATION_REQUIRED: 'Required',

  //burger menu
  MENU_DOWNLOAD: 'Download',
  MENU_DOWNLOAD_TITLE: 'Click here to download OST PST Viewer',
  MENU_FEATURES: 'Features',
  MENU_FEATURES_TITLE: 'Take a Tour (How to sync Outlook. Sync Outlook with Google.)',
  MENU_PRICING: 'Pricing',
  MENU_PRICING_TITLE: 'Pricing',
  MENU_TESTIMONIALS: 'Testimonials',
  MENU_TESTIMONIALS_TITLE: 'Click here to view OST PST Viewer reviews, customer testimonials and feedbacks',
  MENU_FAQ: 'FAQ',
  MENU_FAQ_TITLE: 'Click here to read frequently asked questions',
  MENU_SUPPORT: 'Support',
  MENU_SUPPORT_TITLE: 'Support',
  MENU_RESOURCES: 'Resources',
  MENU_RESOURCES_TITLE: 'Resources',
  MENU_RESOURCES_SCREENSHOTS_VIDEO: 'Screenshots & Videos',
  MENU_RESOURCES_SCREENSHOTS_VIDEO_TITLE: 'Screenshots & Videos',
  MENU_RESOURCES_DOCUMENTATION: 'Documentation',
  MENU_RESOURCES_DOCUMENTATION_TITLE: 'Documentation',
  MENU_RESOURCES_INSTALLATION_INSTRUCTIONS: 'Installation Instructions',
  MENU_RESOURCES_INSTALLATION_INSTRUCTIONS_TITLE: 'Installation Instructions',
  MENU_RESOURCES_VERSION_HISTORY: 'Version history',
  MENU_RESOURCES_VERSION_HISTORY_TITLE: 'Version history',
  MENU_RESOURCES_SYSTEM_REQUIREMENTS: 'System requirements',
  MENU_RESOURCES_SYSTEM_REQUIREMENTS_TITLE: 'System requirements',
  MENU_RESOURCES_FAQ: 'Frequently Asked Questions',
  MENU_RESOURCES_FAQ_TITLE: 'Frequently Asked Questions',
  MENU_RESOURCES_HELP: 'Help',
  MENU_RESOURCES_HELP_TITLE: 'Help',
  MENU_MY_ACCOUNT: 'My Account',
  MENU_MY_ACCOUNT_TITLE: 'Review your account details',
  MENU_SELECT_LANG: 'Select Your Language',
  MENU_SELECT_LANG_TITLE: 'Select Your Language',
  MENU_CLOSE: 'Close',

  GLEAM_BANNER_DISCOUNT_TEXT_PROMO_CODE: 'Your 50% discount Promo Code:',
  GLEAM_BANNER_DISCOUNT_TEXT_PRODUCT_WIIL_COST: 'OST PST Viewer will cost you',
  GLEAM_BANNER_DISCOUNT_TEXT_APPLY_DISCOUNT: 'Enter your Promo Code in the Shopping Cart to take advantage of this discount.',

  //PAGE LINKS:
  URL_ABOUT_US: "https://www.ostpstviewer.com/WebHelp/OSTPSTViewerHelp.htm#About_PST_Viewer.htm",
  URL_LICENSING: "https://www.4team.biz/eula.aspx",
  URL_FAQ: "https://www.ostpstviewer.com/frequently-asked-questions.aspx",
  URL_SYSTEM_REQUIREMENTS: "https://www.ostpstviewer.com/system-requirements.aspx",
  URL_SUPPORT: "https://www.4team.biz/livehelp.aspx",
  URL_REFUND_POLICY: "https://www.ostpstviewer.com/refundpolicy.aspx",


  //structured data
  SD_PR_NAME:"OST PST Viewer",
  SD_PR_DESCRIPTION:"Purchase, buy #PR_NAME# license and activation code. Order Outlook Tech Support and #PR_NAME# bundle.",
  SD_PR_IMAGE:"https://www.ostpstviewer.com/i/OST_PST_Viewer_logo.png",
  SD_PR_OPERATING_SYSTEM:"Windows",
  SD_PR_VERSION:"1.30.0132",
  SD_PR_CATEGORY:"Productivity",
  SD_PR_DOWNLOAD_URL:"https://www.ostpstviewer.com/download.aspx",
  SD_PR_RELEASE_NOTES:"https://www.ostpstviewer.com/version-history.aspx",
  SD_PR_AUTHOR_NAME:"4Team Corporation",
  SD_PR_URL:"https://www.ostpstviewer.com/",

  SD_OFFERS_PRICE_CURRENCY_USD:"USD",
  SD_OFFERS_PRICE_USD:"79.95",
  SD_OFFERS_URL_USD:"https://www.ostpstviewer.com/purchase/licenses",

  SD_OFFERS_PRICE_CURRENCY_GBP:"GBP",
  SD_OFFERS_PRICE_GBP:"59.95",
  SD_OFFERS_URL_GBP:"https://www.ostpstviewer.com/purchase/licenses",
  
  SD_OFFERS_PRICE_CURRENCY_EUR:"EUR",
  SD_OFFERS_PRICE_EUR:"79.95",
  SD_OFFERS_URL_EUR:"https://www.ostpstviewer.com/purchase/licenses",
  
  SD_RATING_WORST:"1",
  SD_RATING_BEST:"5",
  SD_RATING_VALUE:"4.8",
  SD_RATING_COUNT:"295",

  SD_ORGANIZATION_NAME:"4Team Corporation",
  SD_ORGANIZATION_IMAGE:"https://www.4team.biz/i/4Team_logo_2.png",
  SD_ORGANIZATION_URL:"https://www.4team.biz",
  SD_ORGANIZATION_ADDRESS:"5645 Coral Ridge Dr #211",
  SD_ORGANIZATION_CITY:"Coral Springs",
  SD_ORGANIZATION_REGION:"FL",
  SD_ORGANIZATION_ZIP:"33076",
  SD_ORGANIZATION_COUNTRY:"USA",
  SD_ORGANIZATION_PHONE_USA:" +1 (954) 796-8161",
  SD_ORGANIZATION_PHONE_UK:" +44 20 3371 8464",
  SD_ORGANIZATION_PHONE_CANADA:"+1 647 477-3340",
  SD_ORGANIZATION_PHONE_FRANCE:"+33 1 86 26 42",
  //end structured data
}
